import React from "react";
import "../gallery-components/CSRGallery.css";

const ContactHeader = () => {
  return (
    <section className="csr-header back">
      <div className="container h-100">
        <div className="row h-100 align-items-center">
          <div className="col-12 text-center">
            <h1 className="gallery-title fw-bold mb-2">
                Contact Us
            </h1>

            <p className="gallery-subtitle mb-0 mx-auto">
              Get in touch with us for any inquiries, support, or feedback regarding our services.
              and community transformation across Maharashtra
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHeader;
